module.exports = __webpack_public_path__ + "img/1537819569.617e0743.jpg";